export * from 'effect/Record';
//#region Iterable
/**
 * Same as Object.values but returns iterator instead of array
 */
export function* values(record) {
    for (const key in record) {
        yield record[key];
    }
}
/**
 * Same as Object.entries but returns iterator instead of array
 */
export function* entries(record) {
    for (const key in record) {
        yield [key, record[key]];
    }
}
/**
 * Same as Object.keys but returns iterator instead of array
 */
export function* keys(record) {
    for (const key in record) {
        yield key;
    }
}
//#endregion
//# sourceMappingURL=Record.js.map